/* eslint global-require: 0, no-empty: 0 */
import Sticky from 'sticky-js';
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';

export default class Glossaire {
  constructor() {
    const glossaireLetters = [...document.querySelectorAll('.glossaire-letter')];
    this.stickyCol = null;

    if (glossaireLetters && glossaireLetters.length) {
      glossaireLetters.forEach((letter) => {
        letter.addEventListener('click', this.filterByLetter);
      });
    }

    if (window.innerWidth <= 992) {
      this.stickyCol = new Sticky('.js-glossaire-inner');

      const glossaireLettersMobile = [...document.querySelectorAll('.glossaire-mobile-letter')];
      glossaireLettersMobile.forEach((letterMobile) => {
        letterMobile.addEventListener('mouseover', this.scrollToLetter);
      });
    } else {
      const firstLetter = document.querySelector('.glossaire-letter:first-child');

      if (firstLetter) firstLetter.click();
    }
  }

  filterByLetter(event) {
    const letter = event.target;
    const glossaireLetters = [...document.querySelectorAll('.glossaire-letter')];
    let productsToShow;

    if (letter.innerHTML === '#') {
      productsToShow = document.querySelector('.letter-hashtag');
    } else {
      productsToShow = document.querySelector(`.letter-${letter.innerHTML}`);
    }

    glossaireLetters.forEach((el) => el.classList.remove('active'));
    letter.classList.add('active');

    const productsToHide = [...document.querySelectorAll('.letter-block')];
    delete productsToHide[productsToHide.indexOf(productsToShow)];

    productsToHide.forEach((product) => {
      Velocity(product, 'fadeOut', {
        duration: 600,
        easing: 'easeInOutQuad',
      });
    });

    Velocity(productsToShow, 'fadeIn', {
      duration: 600,
      delay: 700,
      easing: 'easeInOutQuad',
    });
  }

  scrollToLetter(event) {
    let letter = event.target.innerHTML;

    if (letter === '#') letter = 'hashtag';

    const target = document.querySelector(`#${letter}`);

    Velocity(target, 'scroll', {
      duration: 500,
      offset: -80,
    });
  }
}
